export default "__VITE_ASSET__C_HR3YKB__"